import { DataTable } from "primereact/datatable";
import REIToggablePanel from "../../../components/ui/toggablePanel";
import { Column } from "primereact/column";
import { formatCurrency, formatNumberWithDecimal } from "../../../utils/commonUtil";
import { useNavigate } from "react-router-dom";

interface IPropertyStats {
  name: string;
  value: number;
  netEquity: number;
  lvr: number;
  dsr: number;
  capitalGrowth: number;
  growth: number;
  propertyId: string;
}

const PropertiesAtGlance: React.FC<{ properties: IPropertyStats[] }> = ({ properties }) => {
  const currencyTemplate = (value: number) => (
    <span className={value < 0 ? "text-red-600" : ""}>
      {value < 0 ? `(${formatCurrency(-value)})` : formatCurrency(value)}
    </span>
  );
  const navigate = useNavigate();

  return (
    <div>
      <REIToggablePanel
        header={"YOUR PROPERTIES AT A GLANCE"}
        istoggleable={false}
        defaultCollapse={false}
        contentComponent={
          <div className="altRowShade">
            <DataTable value={properties}>
              <Column
                body={(rowData) => (
                  <a
                    id={`megpag-lnk-address-${rowData.propertyId}`}
                    data-testid={`megpag-lnk-address-${rowData.propertyId}`}
                    className="cursor-pointer text-blue-700 no-underline"
                    onClick={() => {
                      navigate(`/portfolio-tracker`, {
                        state: {
                          tab: "MyPropertyTab",
                          MyPropertyId: rowData.propertyId,
                        },
                      });
                    }}
                  >
                    {rowData.name}
                  </a>
                )}
                field="name"
                header="Address/Property Name"
              ></Column>
              <Column field="value" header="Value" body={(rowData) => currencyTemplate(rowData.value)}></Column>
              <Column
                field="netEquity"
                header="Net Equity"
                body={(rowData) => currencyTemplate(rowData.netEquity)}
              ></Column>
              <Column
                field="lvr"
                header="LVR"
                body={(rowData) =>
                  rowData.lvr < 0
                    ? `(${formatNumberWithDecimal(Math.abs(rowData.lvr), 0, 0)}%)`
                    : `${formatNumberWithDecimal(rowData.lvr, 0, 0)}%`
                }
              ></Column>
              <Column
                field="dsr"
                header="DSR"
                body={(rowData) => {
                  return rowData < 0
                    ? `(${formatNumberWithDecimal(rowData.dsr, 2, 2)})`
                    : formatNumberWithDecimal(rowData.dsr, 2, 2);
                }}
              ></Column>
              <Column
                field="capitalGrowth"
                header="Capital Growth"
                body={(rowData) => currencyTemplate(rowData.capitalGrowth)}
              ></Column>
              <Column
                field="growth"
                header="Growth"
                body={(rowData) =>
                  rowData.growth < 0
                    ? `(${formatNumberWithDecimal(Math.abs(rowData.growth), 0, 0)}%)`
                    : `${formatNumberWithDecimal(rowData.growth, 0, 0)}%`
                }
                bodyClassName={(rowData) => (rowData.growth < 0 ? "text-red-500" : "")}
              ></Column>
            </DataTable>
          </div>
        }
      />
    </div>
  );
};

export default PropertiesAtGlance;
